import { FC, useEffect, useMemo, useState } from "react";
import "./benefits.scss";
import { IMAGE_URL_CONFIG } from "../../../../constants/url";
import { RootState } from "../../../../store";
import { useDispatch, useSelector } from "react-redux";
import { formatMembershipType } from "../../../../utils/rewards";
import { COUNTRY, MEMBERSHIP_TYPE } from "../../../../constants/app";
import { setContentModal, toggleContentModal } from "../../../../store/application/action";
import { ROUTES } from "../../../../constants/path";
import { upgrademembership } from "../../../../services/rewards";
import { pageContentApi } from "../../../../services/sideMenus";
import { MEMBERSHIP_CONTENT } from "../../../../constants/membership";


interface IBenefitsProps { }

const Benefits: FC<IBenefitsProps> = () => {

    const { memberDetail, currentCinema, userDetails, countryId } = useSelector(
        (state: RootState) => ({
            memberDetail: state.authReducer.memberDetail,
            currentCinema: state.applicationReducer.currentCinema,
            userDetails: state.authReducer.userDetails,
            countryId: state.applicationReducer.countryId
        })
    );

    const dispatch = useDispatch();

    const membershipType = useMemo(() => {
        return formatMembershipType(memberDetail!)
    }, [memberDetail])

    const cancelSubscrption = () => {
        dispatch(setContentModal({ type: ROUTES.CANCEL_MEMBERSHIP }));
        dispatch(toggleContentModal(true));
    }

    const onUpgrade = async () => {
        await upgrademembership(countryId, currentCinema, userDetails, dispatch);
    };

    const logo = useMemo(() => {
        if (countryId) {
            if (countryId === COUNTRY.STA) {
                return {
                    free: MEMBERSHIP_CONTENT[COUNTRY.STA]['BASIC']['logo'],
                    paid: MEMBERSHIP_CONTENT[COUNTRY.STA]['BOOST']['logo']
                }
            } else if (countryId === COUNTRY.ANG) {
                return {
                    free: MEMBERSHIP_CONTENT[COUNTRY.ANG]['CLUB']['logo'],
                    paid: MEMBERSHIP_CONTENT[COUNTRY.ANG]['GOLD']['logo']
                }
            } else {
                return {
                    free: MEMBERSHIP_CONTENT[COUNTRY.AUS]['BASIC']['logo'],
                    paid: MEMBERSHIP_CONTENT[COUNTRY.AUS]['BOOST']['logo']
                }
            }
        } else {
            return {
                free: '',
                paid: ''
            };
        }
    }, [countryId])

    const ticketDiscount = useMemo(() => {
        switch (countryId) {
            case COUNTRY.ANG:
                return {
                    point: 20,
                    tickets: '20% off two tickets per session'
                }
            default:
                return {
                    point: 15,
                    tickets: '15% off one ticket per session'
                }
        }
    }, [countryId])

    return (
        <div className="benefits_category">
            <div className="benefits_item">
                <div className={`benefit_gold brand_${countryId}`}>
                    <div className="logo">
                        <img
                            className="w-100"
                            src={
                                `${IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH}` + logo.paid
                            }
                        />
                    </div>
                    <div className="details_gold">
                        <div className="gold_heading">$20 Annual Membership</div>
                        <div className="gold_body">
                            <div className="description_gold underline_seperate">{ticketDiscount.point}% off tickets* <br /><span className="fn-14">All sessions, every day</span></div>
                            <div className="description_gold underline_seperate">10% off food & beverage <br /><span className="fn-14">All sessions, every day</span></div>
                            <div className="fn-14 underline_seperate">Collect 20 points per dollar spent</div>
                            <div className="fn-14 underline_seperate">Tuesday Rewards. Get discounted movie tickets every Tuesday</div>
                            <div className="fn-14 underline_seperate">Various redeemable rewards</div>
                            <div className="fn-14 underline_seperate">Redeem your points for discounts, snacks and tickets at the cinema</div>
                            <div className="fn-14 underline_seperate">Access to exclusive member only competitions and screenings</div>
                            <div className="fn-14 underline_seperate">Stay up to date with our weekly e-newsletter</div>
                            <div className="fn-12">*{ticketDiscount.tickets}</div>
                        </div>

                    </div>
                    {membershipType === MEMBERSHIP_TYPE.GOLD ?
                        <h5 className="active-membership"><img src={
                            IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH +
                            "tick_circle.svg"
                        } alt="" /><span>Current membership</span></h5> : null}
                </div>
                <div className={`benefit_club brand_${countryId}`}>
                    <div className="logo">
                        <img
                            className="w-100"
                            src={
                                IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH +
                                logo.free
                            }
                        />
                    </div>
                    <div className="details_club">
                        <div className="club_heading">Free Membership</div>
                        <div className="club_body">
                            <div className="fn-14 underline_seperate">Collect 10 points per dollar spent</div>
                            <div className="fn-14 underline_seperate">Tuesday Rewards. Get discounted movie tickets every Tuesday</div>
                            <div className="fn-14 underline_seperate">Various redeemable rewards</div>
                            <div className="fn-14 underline_seperate">Redeem your points for discounts, snacks and tickets at the cinema</div>
                            <div className="fn-14 underline_seperate">Access to exclusive member only competitions and screenings</div>
                            <div className="fn-14">Stay up to date with our weekly e-newsletter</div>
                        </div>

                    </div>
                    {membershipType === MEMBERSHIP_TYPE.CLUB ?
                        <h5 className="active-membership"><img src={
                            IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH +
                            "tick_circle.svg"
                        } alt="" /><span>Current membership</span></h5> : null}
                </div>
            </div>
            <div className="mb-4 text-center">
                {membershipType === MEMBERSHIP_TYPE.GOLD ?
                    // <button className="btn btn_black" onClick={cancelSubscrption}>CANCEL ANGELIKA REWARD GOLD</button>
                    null
                    :
                    <>
                        <div className="upgrade_to_angelika">Upgrade to {countryId === COUNTRY.AUS || countryId === COUNTRY.NZ?'Reading Rewards Boost':'Angelika Rewards Gold'}</div>
                        <button className={`btn ${countryId === COUNTRY.ANG?'btn-gold':'btn-boost' }`} onClick={onUpgrade}>UPGRADE NOW</button>
                    </>
                }
            </div>
        </div>
    );
};

export default Benefits;
